export default __webpack_public_path__ + "static/media/newspaper.b6e02e8a.jpg";